import React from "react";
import { Button, Modal } from "components/haven-design";
import { DialogActions } from "components/haven-design/modal/dialog";

type CopyConfirmationModalProps = {
  isOpen: boolean;
  onConfirmation: () => void;
  onClose: () => void;
  context: "Letter" | "Email";
}

const CopyConfirmationModal:React.FC<CopyConfirmationModalProps> =
  ({ isOpen, onClose, onConfirmation, context }) => <Modal
    title={`Overwrite the ${context.toLowerCase()} content?`}
    isOpen={isOpen}
    onRequestClose={onClose}
    small
  >
    <DialogActions>
      <Button
        size="L"
        color="secondary"
        onClick={onClose}
      >
        Cancel
      </Button>
      <Button
        size="L"
        color="primary"
        onClick={onConfirmation}
      >
        Overwrite
      </Button>
    </DialogActions>
  </Modal>;

export default CopyConfirmationModal;
